import { Component, importProvidersFrom, OnDestroy, OnInit } from '@angular/core';
import { BaseAthleteAnswer } from '../base-athlete-answer';
import { FeedbackHurtAthleteDialogComponent } from './feedback-hurt-athlete-dialog.component';
import { Human } from '../../human';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackQuestion } from '../../../common/models/feedback-question';
import { FlexLayoutModule } from "@angular/flex-layout";
import { NgForOf } from "@angular/common";

@Component({
  selector: 'app-feedback-hurt-athlete-answer',
  templateUrl: 'feedback-hurt-athlete-answer.component.html',
  standalone: true,
  imports: [
    FlexLayoutModule,
    NgForOf,
  ],
  styleUrls: ['../athlete-answers.css']
})
export class FeedbackHurtAthleteAnswerComponent extends BaseAthleteAnswer implements OnInit, OnDestroy {

    public static type = FeedbackQuestion.TYPE_HURT;
    public backPaths: Path[] = Human.backPaths;
    public frontPaths: Path[] = Human.frontPaths;
    private subscriptions: Subscription[] = [];

    constructor(public dialog: MatDialog) {
        super();
    }

    public ngOnInit(): void {
        this.changeBodyPartColor();
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public showDialog(path:any) {
        const d = this.findByData(this.data, path.identifier);
        if (d && 'undefined' !== d && 0 < d.answerUserData) {
            const dialogRef = this.dialog.open(FeedbackHurtAthleteDialogComponent, {
                width: '250px',
                data: d
            });

            this.subscriptions.push(
                dialogRef.afterClosed().subscribe((result) => {
                })
            );
        }
    }

    public findByData(feedbackAnswers:any, data:any) {
        return feedbackAnswers.find((x:any) => x.answerValue === data);
    }

    private changeBodyPartColor() {
        (async () => {
            const humanParts = [...this.backPaths, ...this.frontPaths];
            for (const part of this.data) {
                const p = this.findSvgPathByIdentifier(humanParts, part['answerValue']);

                const color = Human.colors[part['answerUserData']];
                if (color && color !== 'undefined') {
                    p.fill = color;
                }
            }
        })();
    }

    private findSvgPathByIdentifier(data:any, attrValue:any) {
        return data.find((x:any) => x.identifier === attrValue);
    }
}

interface Path {
    path: string;
    identifier: string;
    borderSize?: number;
    borderColor?: string;
    x?: number;
    y?: number;
    fill?: string;
}
